import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getArticle } from '../api/strapiClient';

function formatDateline(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d
    .toLocaleDateString(undefined, { month: 'short', day: '2-digit', year: 'numeric' })
    .toUpperCase();
}

export default function ArticlePage() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    getArticle(id)
      .then((res) => {
        if (!cancelled) setArticle(res.data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Unknown error');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) return <main className="page state-message">Loading article…</main>;
  if (error)
    return (
      <main className="page state-message state-message--error">
        Couldn't reach the newsroom. {error}
      </main>
    );
  if (!article) return <main className="page state-message">Article not found.</main>;

  const {
    url,
    publishedDate,
    category,
    title,
    summary,
    tags,
    imageUrl,
    journalist: j,
    publication: pub,
  } = article;

  return (
    <main className="page article-page">
      <Link to="/" className="back-link">
        ← Back to the wire
      </Link>

      <article>
        <div className="article-page__dateline">
          <span className="article-card__category">{category}</span>
          <span className="article-card__date">{formatDateline(publishedDate)}</span>
        </div>

        <h1 className="article-page__title">{title}</h1>

        <div className="article-page__byline">
          {j ? (
            <Link to={`/journalists/${j.documentId}`} className="article-card__byline">
              By {j.firstName} {j.lastName}
            </Link>
          ) : (
            <span className="article-card__byline article-card__byline--muted">
              Unknown journalist
            </span>
          )}
          {pub && (
            <a
              href={pub.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="article-card__publication"
            >
              {pub.name}
            </a>
          )}
        </div>

        {imageUrl && (
          <img src={imageUrl} alt="" className="article-page__image" />
        )}

        {summary && <p className="article-page__summary">{summary}</p>}

        {tags?.length > 0 && (
          <div className="article-card__tags">
            {tags.map((tag, i) => (
              <span key={tag.id ?? i} className="article-card__tag">
                #{tag.value}
              </span>
            ))}
          </div>
        )}

        {url && (
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="article-page__source-link"
          >
            Read the full article at {pub?.name || 'the source'} ↗
          </a>
        )}
      </article>
    </main>
  );
}
